module.exports = __webpack_public_path__ + "img/form-bg-3.3710d2b8.svg";